<template>
  <div>
    <rueden-header title="Betriebsschließung - Kostenlose Erstberatung"/>

    <!-- 1 Anspruch -->
    <div class="container pt-4 pt-md-5 pb-5" v-if="step === 1">

      <schrittanzeige
        :step="step"
        :last="stepCount"
        title="Sie sind von einer Betriebsschließung betroffen? Wir helfen Ihnen!"
      />

      <form name="betriebsschliessung_1" id="form_1">
        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2">
            <div class="formular-box">

              <div class="row">
                <div class="col-12">
                  <h2 class="mt-0 pt-0 mb-0 pb-4 pb-md-5">1. Angaben zu Ihrem Betrieb</h2>
                </div>
              </div>

              <suggest-input
                key="FalldatenBetriebsart"
                v-model="falldaten.betriebsart"
                label="Welche Art von Betrieb führen Sie?"
                :list="[
                  'Restaurant oder Café',
                  'Bar oder Kneipe',
                  'Beherbergung wie Hotel oder Pension',
                  'Club',
                  'Freizeit- oder Veranstaltungsbetrieb',
                  'Catering'
                ]"
                :required="true"
              />

              <div class="row">
                <select-input
                    key="FalldatenAnzahlVerweigert"
                    v-model="falldaten.anzahl_verweigert"
                    :list="[
                    {text: '1', value: '1'},
                    {text: '2', value: '2'},
                    {text: '3', value: '3'},
                    {text: '4', value: '4'},
                    {text: '5', value: '5'},
                    {text: 'mehr als 5', value: 'mehr als 5'},
                    {text: 'weiß ich nicht', value: 'weiß ich nicht'},
                  ]"
                    label="Für wie viele Ihrer Betriebe verweigert die Betriebsschließungsversicherung eine Zahlung?"
                    :required="true"
                />
              </div>

              <div class="row">
                <select-input
                    key="FalldatenBereitsAntrag"
                    v-model="falldaten.bereits_antrag"
                    :list="[
                    {text: 'Ja', value: 'Ja'},
                    {text: 'Nein', value: 'Nein'},
                  ]"
                    label="Haben Sie den Antrag auf Zahlung bei Ihrer Versicherung eingereicht?"
                    :required="true"
                />
              </div>

              <div class="row">
                <select-input
                    key="FalldatenBereitsAusgezahl"
                    v-model="falldaten.bereits_ausgezahlt"
                    :list="[
                    {text: 'Ja', value: 'Ja'},
                    {text: 'Nein', value: 'Nein'},
                  ]"
                    label="Hat Ihnen Ihre Versicherung etwas ausgezahlt?"
                    :required="true"
                />
              </div>

              <div class="row">
                <select-input
                    v-if="falldaten.bereits_ausgezahlt == 'Ja'"
                    key="FalldatenBereitsAusgezahltJa"
                    v-model="falldaten.bereits_ausgezahlt_ja_wert"
                    :list="[
                    {text: 'Die vollständige Versicherungsumme', value: 'Die vollständige Versicherungsumme'},
                    {text: 'Einen Anteil der Versicherungssumme', value: 'Einen Anteil der Versicherungssumme'},
                  ]"
                    :required="true"
                />
                <select-input
                    key="FalldatenBereitsAusgezahltNein"
                    v-if="falldaten.bereits_ausgezahlt == 'Nein'"
                    v-model="falldaten.bereits_ausgezahlt_nein_wert"
                    :list="[
                    {text: 'Ich habe auch kein Angebot bekommen', value: 'Ich habe auch kein Angebot bekommen'},
                    {text: 'Ich habe ein niedriges Angebot bekommen und abgelehnt', value: 'Ich habe ein niedriges Angebot bekommen und abgelehnt'},
                  ]"
                    :required="true"
                />
              </div>

              <next-back-step
                key="nextBack1"
                v-model="step"
              />

            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="container pt-4 pt-md-5 pb-5" v-if="step === 2">
      <form name="betriebsschliessung_2" id="form_2" autocomplete="off">
        <schrittanzeige
            :step="step"
            :last="stepCount"
            title="Sie sind von einer Betriebsschließung betroffen? Wir helfen Ihnen!"
        />

        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2">
            <div class="formular-box">
              <div class="row">
                <div class="col-12">
                  <h2 class="mt-0 pt-0 mb-0 pb-4 pb-md-5">2. Ihr Betrieb</h2>
                </div>
              </div>

              <div class="row">
                <text-input
                    key="FalldatenUnternehmensname"
                    v-model="falldaten.unternehmensname"
                    label="Name des Unternehmens"
                    :required="true"
                    col="col-12 col-md-12"
                />
              </div>

              <div class="row">
                <text-input
                    key="StammdatenPLZ"
                    v-model="stammdaten.plz"
                    label="Postleitzahl"
                    type="zip"
                    :required="true"
                />
                <text-input
                    key="StammdatenOrt"
                    v-model="stammdaten.ort"
                    label="Ort"
                    :required="true"
                />
              </div>

              <next-back-step
                  key="nextBack2"
                  v-model="step"
              />

            </div>
          </div>
        </div>
      </form>
    </div>


    <!-- 3. Antragssteller  -->
    <div class="container pt-4 pt-md-5 pb-5" v-if="step === 3">
      <form name="betriebsschliessung_3" id="form_3" autocomplete="off">
        <schrittanzeige
          :step="step"
          :last="stepCount"
          title="Sie sind von einer Betriebsschließung betroffen? Wir helfen Ihnen!"
        />

        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2">
            <div class="formular-box">
              <div class="row">
                <div class="col-12">
                  <h2 class="mt-0 pt-0 mb-0 pb-4 pb-md-5">3. Persönliche Angaben</h2>
                </div>
              </div>

              <div class="row">
                <select-input
                  key="StammdatenAnrede"
                  v-model="stammdaten.anrede"
                  :list="[
                    {text: 'Frau', value: 'Frau'},
                    {text: 'Herr', value: 'Herr'},
                  ]"
                  :required="true"
                />
              </div>

              <div class="row">
                <text-input
                  key="StammdatenVorname"
                  v-model="stammdaten.vorname"
                  label="Vorname"
                  :required="true"
                />
                <text-input
                  key="StammdatenNachname"
                  v-model="stammdaten.nachname"
                  label="Nachname"
                  :required="true"
                />
              </div>

              <div class="row">
                <text-input
                  key="StammdatenEmail"
                  v-model="stammdaten.email"
                  label="E-Mail"
                  type="email"
                  :required="true"
                />
                <text-input
                    key="StammdatenTelefon"
                    v-model="stammdaten.telefon"
                    label="Telefon"
                    type="tel"
                    :required="true"
                />
              </div>


              <next-back-step
                key="nextBack3"
                v-model="step"
                submitButton="Erstberatung anfordern"
              />

            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="container pt-4 pt-md-5 pb-5" v-if="step === 4">
      <schrittanzeige
          :step="step"
          :last="stepCount"
          title="Sie sind von einer Betriebsschließung betroffen? Wir helfen Ihnen!"
      />
      <abschluss
          :error="error"
      />
    </div>

    <!-- datenschutzlogo immer anzeigen im formular -->
    <rueden-footer
      :show_berlin="step===3"
      :show_datenschutz="step===3"
    />

  </div>
</template>
<script>
import TextInput from "@/components/all/text-input";
const STEP_COUNT = 4;

import General from '@/mixins/general';

import RuedenHeader from '@/components/all/rueden-header';
import Schrittanzeige from '@/components/all/schrittanzeige';
import SelectInput from "@/components/all/select-input";
import NextBackStep from "@/components/all/next-back-buttons";
import RuedenFooter from "@/components/all/rueden-footer";
import Abschluss from "@/components/all/abschluss";
import SuggestInput from "@/components/all/suggest-input";


export default {

  mixins: [General],

  components: {
    RuedenFooter,
    Abschluss,
    TextInput,
    RuedenHeader,
    Schrittanzeige,
    SelectInput,
    NextBackStep,
    SuggestInput,
  },

  data() {
    return {
      stepCount: STEP_COUNT,
      step: 1,
      stammdaten: {
        anrede: 'Frau',
      },
      falldaten: {
        betriebsart: this.$route.query.betriebsart
      },
      error: null,
    }
  },
  mounted() {
    document.title = 'Betriebsschließung - Kostenlose Erstberatung';
    this.$global.geCat = 'Lead Funnel Betriebsschließung';
  },
  watch: {
    step: function (curStep) {
      if (curStep == this.stepCount) {
        this.error = this.submitToFlowGeneral(this.stammdaten,'Betriebsschließung',this.falldaten,this.gaCat);
      }
    }
  },
}
</script>
